/** @type {import('tailwindcss').Config} */
export default {
    content: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
    media: false,
    variants: {
      extend: {},
    },
    plugins: [],
    theme: {
        colors: {
            transparent : 'transparent',
            black : '#000000',
            white : '#ffffff',
            gold : '#FFBD25',
            'bhav-blue': {
                DEFAULT: '#1A3464',
                50: '#E8EBF0',
                100: '#D1D6E0',
                200: '#A3AEC1',
                300: '#7685A2',
                400: '#485D83',
                500: '#1A3464',
                600: '#152A50',
                700: '#101F3C',
                800: '#0A1528',
                900: '#050A14',
            },
            'bhav-green': {
                DEFAULT: '#79AC00',
                100: '#EAF7CC',
                600: '#79AC00',
                700: '#5B8100',
            },
            'bhav-red': {
                DEFAULT: '#D91F1F',
                100: '#F7D2D2',
                200: '#F0A8A8',
                300: '#E87E7E',
                400: '#DF5454',
                500: '#D91F1F',
                600: '#AB1919',
            },
            'bhav-bright-blue': {
                50: '#E6F2FF',
                100: '#CCE4FF',
                500: '#007AFF'
            },
            'bhav-cool-gray': {
                50: '#F6F6F6',
                100: '#E4E4E5',
                500: '#76777B',
                600: '#5E5F62',
                900: '#181819'
            },
            'bhav-orange': {
                DEFAULT: '#D7592A',
                100: '#F7DED4',
                500: '#D7592A',
            },
            'oakwood-blue': {
                DEFAULT: '#1A3464',
                50: '#C1DEEF',
                100: '#B1D4EB',
                200: '#91BFE2',
                300: '#70A9DA',
                400: '#5090D1',
                500: '#3377C5',
                600: '#2B5FA5',
                700: '#224884',
                800: '#1A3464',
                900: '#0E1B37',
                950: '#091021'
            },
            'oakwood-green': {
                DEFAULT: '#79AC00',
                50: '#F5FBE6',
                100: '#EAF7CC',
                200: '#D5EF99',
                300: '#C1E766',
                400: '#ACDF33',
                500: '#97D700',
                600: '#79AC00',
                700: '#5B8100',
                800: '#3C5600',
                900: '#1E2B00'
            },
            'oakwood-red': {
                DEFAULT: '#C32222',
                50: '#FDF2F2',
                100: '#FAE1E1',
                200: '#F4BEBE',
                300: '#ED9B9B',
                400: '#E77979',
                500: '#E15656',
                600: '#DB3333',
                700: '#C32222',
                800: '#931A1A',
                900: '#641212',
                950: '#4C0D0D'
            },
            'oakwood-gray': {
                DEFAULT: '#585347',
                50: '#EBE9E6',
                100: '#E2E0DB',
                200: '#D0CCC4',
                300: '#BDB9AE',
                400: '#ABA597',
                500: '#999280',
                600: '#857E6B',
                700: '#6F6859',
                800: '#585347',
                900: '#39362E',
                950: '#292721'
            },
            blue: {
                DEFAULT: '#0C7BCC',
                '200': '#CAE6FA',
                '300': '#BEDCF1',
                '400': '#485D83',
                '500': '#1A3464',
                '900': '#0C7BCC',
            },
            green: {
                DEFAULT: '#0B8F30',
                '200': '#D6F2D7',
                '300': '#C6E5C7',
                '500': '#97D700',
                '600': '#79AC00',
                '900': '#0B8F30'
            },
            gold: {
                DEFAULT: '#d6af1c',
                '50': '#fcfbea',
                '100': '#f9f7c8',
                '200': '#f4eb94',
                '300': '#edda57',
                '400': '#e5c41f',
                '500': '#d6af1c',
                '600': '#b98a15',
                '700': '#946414',
                '800': '#7b4f18',
                '900': '#69421a',
                '950': '#3d230b',
            },
            'oakwood-orange': {
                DEFAULT: '#d96d00',
                '50': '#fffaea',
                '100': '#fff2c5',
                '200': '#ffe487',
                '300': '#ffd048',
                '400': '#ffbb1e',
                '500': '#fc9804',
                '600': '#d96d00',
                '700': '#b94c04',
                '800': '#963a0a',
                '900': '#7b300c',
                '950': '#471701',
            },
        },
        fontFamily: {
            sans: ['roboto', 'Arial', 'sans-serif'],
            headline: ['gotham', 'Arial', 'sans-serif']
        },
        extend: {}
    },
  }